import script from "./ModalEditarPairing.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalEditarPairing.vue?vue&type=script&setup=true&lang=ts"

import "./ModalEditarPairing.vue?vue&type=style&index=0&id=3efdf0aa&lang=css"

const __exports__ = script;

export default __exports__